import {Action} from "redux";
import {GetCustomersBySalesCampaignPageRequest} from "../request/customer_request";
import {GetCustomersByClientSalesCampaignPageResponse} from "../response/customer_response";

export enum ClientSalesCampaignActionType {
    REQUEST_GET_CUSTOMERS = "CLIENT_SALES_CAMPAIGN_REQUEST_GET_CUSTOMERS",
    CALLBACK_GET_CUSTOMERS = "CLIENT_SALES_CAMPAIGN_CALLBACK_GET_CUSTOMERS",
}

export interface IRequestGetCustomerByClientSalesCampaignPageAction extends Action {
    type: ClientSalesCampaignActionType.REQUEST_GET_CUSTOMERS;
    item: GetCustomersBySalesCampaignPageRequest;
}
export interface ICallbackGetCustomerByClientSalesCampaignPageAction extends Action {
    type: ClientSalesCampaignActionType.CALLBACK_GET_CUSTOMERS;
    isSuccess: boolean;
    item?: GetCustomersByClientSalesCampaignPageResponse;
}

export type ClientSalesCampaignAction =
    IRequestGetCustomerByClientSalesCampaignPageAction |
    ICallbackGetCustomerByClientSalesCampaignPageAction;

export interface IClientSalesCampaignActionCreator {

    requestGetCustomerByClientSalesCampaignPageAction(
        item: GetCustomersBySalesCampaignPageRequest
    ): IRequestGetCustomerByClientSalesCampaignPageAction;

    callbackGetCustomerByClientSalesCampaignPageAction(
        isSuccess: boolean,
        item?: GetCustomersByClientSalesCampaignPageResponse,
    ): ICallbackGetCustomerByClientSalesCampaignPageAction;

}

class ActionCreator implements IClientSalesCampaignActionCreator {

    public requestGetCustomerByClientSalesCampaignPageAction = (
        item: GetCustomersBySalesCampaignPageRequest
    ): IRequestGetCustomerByClientSalesCampaignPageAction => {
        return {
            type: ClientSalesCampaignActionType.REQUEST_GET_CUSTOMERS,
            item,
        };
    };

    public callbackGetCustomerByClientSalesCampaignPageAction = (
        isSuccess: boolean,
        item?: GetCustomersByClientSalesCampaignPageResponse,
    ): ICallbackGetCustomerByClientSalesCampaignPageAction => {
        return {
            type: ClientSalesCampaignActionType.CALLBACK_GET_CUSTOMERS,
            isSuccess,
            item,
        };
    };

}

export const createClientSalesCampaignActionCreator = (): IClientSalesCampaignActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_sales_campaign.ts